import { T } from "@repo/transifex";

import { BasketHeaderText } from "./basket-header-text";
import { BasketHeaderWrapper } from "./basket-header-wrapper";
import { type BasketHeaderWrapperProps } from "./basket-header-wrapper";

export const BasketHeaderGuest = ({
  isEmpty
}: Pick<BasketHeaderWrapperProps, "isEmpty">) => {
  return (
    <BasketHeaderWrapper isEmpty={isEmpty} isAuthenticated={false}>
      <BasketHeaderText variant="primary" className="text-xl">
        <T _str="Basket" />
      </BasketHeaderText>
    </BasketHeaderWrapper>
  );
};
